import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Label } from "semantic-ui-react";

import { ThunkDispatch } from "redux-thunk";

import { activeCaseMessagesCountSelector } from "../selectors";
import { getAllCaseMessages } from "../actions";

export const CaseConversationTabLabel = (props: { ohCaseId: string}) => {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
    const messageCount: number = useSelector(activeCaseMessagesCountSelector);

    React.useEffect(() => {
        dispatch(getAllCaseMessages(props.ohCaseId));
    }, [dispatch, props.ohCaseId]);

    if (!messageCount || messageCount === 0)
    {
        return null;
    }

    return (
        <Label circular color="red" floating className="document-label">{messageCount}</Label>
    );
};
